import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import Style from './Overview.module.css';
import { Button, ButtonHalf } from '../../../theme/button';
import { useActivePage } from '../../../contexts/ActivePageContext';
import { useAuth } from '../../../contexts/AuthContext';

import { ReactComponent as AirplaneEditIcon } from "../../../assets/icons/svg/airplane-edit.svg";
import { ReactComponent as SendIcon } from "../../../assets/icons/svg/send-variant-outline.svg";

function Overview() {
  const [firstName, setFirstName] = useState(null);
  const [email, setEmail] = useState(null);
  const [logbooks, setLogbooks] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [greeting, setGreeting] = useState(null);
  const { getValidToken } = useAuth();
  const { setActivePage } = useActivePage();

  const userDataOnPageLoad = async () => {
    setLoading(true);
    try {
      const user = localStorage.getItem("user");
      const userObject = JSON.parse(user);
      setEmail(userObject?.email);
      setFirstName(userObject?.firstName);
      setGreeting(userObject?.greeting);

      if (userObject?.email) {
        const result = await queryLogbooksByUserEmail(userObject.email);
        const sortedLogbooks = result
          .sort((a, b) => new Date(b.DateLastAccessed) - new Date(a.DateLastAccessed))
          .slice(0, 3);
        setLogbooks(sortedLogbooks);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    userDataOnPageLoad();
  }, []);

  const queryLogbooksByUserEmail = async (userEmail) => {
    const API_URL =
      "https://ngyk2k01bl.execute-api.us-east-1.amazonaws.com/prod/getLogbooks";
    const validToken = await getValidToken();

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${validToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      return [];
    }
  };

  return (
    <div className={Style.container}>
      {greeting && (
        <h2 className={Style.greeting}>
          {greeting} {firstName}!
        </h2>
      )}
      <h1 className={Style.header}>Let's get loggin</h1>

      <div className={Style.announcements} style={{ borderRadius: "10px" }}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, padding: "25px", textAlign: "center" }}>
            <Lottie
              animationData={require("../../../assets/animations/webdev.json")}
              loop
              className={Style.announcementsLottie}
            />
          </div>
          <div
            style={{
              flex: 1,
              paddingRight: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "21px",
            }}
          >
            The Web App is Live! Dive in and start logging today.
          </div>
        </div>
      </div>

      <div className={Style.functionBoxesRow}>
        <div className={Style.functionBox} onClick={() => setActivePage("logbooks")}>
          <AirplaneEditIcon className={Style.functionIcon} />
          <p className={Style.functionLabel}>Edit</p>
        </div>

        <div className={Style.functionBox} onClick={() => setActivePage("export")}>
          <SendIcon className={Style.functionIcon} />
          <p className={Style.functionLabel}>Export</p>
        </div>
      </div>

      <div className={Style.recentEdits}>
        <div className={Style.recentEditsHeader}>
          <h2>Recent Edits</h2>
          <ButtonHalf onClick={() => setActivePage("logbooks")}>View All</ButtonHalf>
        </div>

        {Array.isArray(logbooks) && logbooks.length > 0 ? (
          logbooks.map((logbook, index) => (
            <div key={index} className={Style.logbookEntryContainer}>
              <div className={Style.textContainer}>
                <p className={Style.logbookName}>{logbook.Name}</p>
                <p className={Style.logbookDateLastAccessed}>
                  {new Date(logbook.DateLastAccessed).toLocaleString()}
                </p>
              </div>
              <Button
                style={{
                  width: "75px",
                  height: "35px",
                }}
                onClick={() => {
                  const tempString = logbook.Data;
                  const array = JSON.parse(tempString);
                  let logbookIndex = {
                    table: logbook.Name,
                    columns: logbook.Columns,
                    rows: logbook.Rows,
                    data: array,
                  };
                  const jsonOutput = [logbookIndex];

                  // Store in localStorage so Edit can pick it up
                  localStorage.setItem("jsonOutput", JSON.stringify(jsonOutput));
                  localStorage.setItem("HashedID", logbook.HashedID);
                  setActivePage("edit");
                }}
              >
                Edit
              </Button>
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", marginTop: "50px", color: "gray" }}>
            No logbooks available.
          </div>
        )}
      </div>
    </div>
  );
}

export default Overview;